var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.60005C23.1 5.00005 22.2 5.30005 21.2 5.40005C22.2 4.80005 23 3.80005 23.4 2.70005C22.4 3.30005 21.4 3.70005 20.3 3.90005C19.4 2.90005 18.1 2.30005 16.7 2.30005C14 2.30005 11.8 4.50005 11.8 7.20005C11.8 7.60005 11.8 8.00005 11.9 8.30005C7.7 8.10005 4.1 6.10005 1.7 3.10005C1.2 3.90005 1 4.70005 1 5.60005C1 7.30005 1.9 8.80005 3.2 9.70005C2.4 9.70005 1.6 9.50005 1 9.10005C1 9.10005 1 9.10005 1 9.20005C1 11.6 2.7 13.6 4.9 14C4.5 14.1 4.1 14.2 3.6 14.2C3.3 14.2 3 14.2 2.7 14.1C3.3 16.1 5.1 17.5 7.3 17.5C5.6 18.8 3.5 19.6 1.2 19.6C0.8 19.6 0.4 19.6 0 19.5C2.2 20.9 4.8 21.7001 7.5 21.7001C16.6 21.7001 21.5 14.2 21.5 7.70005C21.5 7.50005 21.5 7.30005 21.5 7.10005C22.5 6.40005 23.3 5.50005 24 4.60005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiNone);
export default __webpack_public_path__ + "static/media/twi_none.d649bf6dcd58b077dc7f6e3686988e67.svg";
export { ForwardRef as ReactComponent };